import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";
import { requireExhaustive } from "../../shared/src/util";
import { TTransactionType1 } from "../codecs/TransactionType";
import { TCaseSellerReasonForSale1 } from "../codecs/CaseSellerReasonForSale";

export const OnboardingJourney = union([
    literal("sale"),
    literal("probate_sale"),
    literal("divorce_sale"),
    literal("purchase"),
    literal("transfer"),
    literal("divorce_transfer"),
    literal("probate_transfer"),
    literal("remortgage"),
    literal("other"),
]);
export type TOnboardingJourneyCodec = typeof OnboardingJourney;
export type TOnboardingJourney = TTypeOfCodec<TOnboardingJourneyCodec>;

const isProbateReason = (reason: TCaseSellerReasonForSale1): boolean =>
    reason === "probate"
    || reason === "probate_as1"
    || reason === "probate_djp"
    || reason === "probate_concessionary";

export const deriveOnboardingJourney = (
    transactionType: TTransactionType1,
    sellerReasonForSale: TCaseSellerReasonForSale1,
): TOnboardingJourney =>
    transactionType === "sale"
        ? (
            isProbateReason(sellerReasonForSale) ? "probate_sale"
            : sellerReasonForSale === "divorce" ? "divorce_sale"
            : "sale"
        )
    : transactionType === "transfer"
        ? (
            isProbateReason(sellerReasonForSale) ? "probate_transfer"
            : sellerReasonForSale === "divorce" ? "divorce_transfer"
            : "transfer"
        )
    : transactionType === "purchase" ? "purchase"
    : transactionType === "remortgage" ? "remortgage"
    : transactionType === "unknown" ? "other"
    : requireExhaustive(transactionType);
